import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

const options = {
  autoHeight: true,
  autoHeightMin: 477,
  hideTracksWhenNotNeeded: true,
};

const CustomScrollbar = props => {
  const mergeProps = {
    ...options,
    ...props,
  };

  return (
    <Scrollbars
      {...mergeProps}
      renderTrackVertical={props => (
        <div
          {...props}
          style={{
            ...props.style,
            right: 8,
            top: 25,
            bottom: 25,
            height: 'calc(100% - 50px)',
          }}
          className="track-vertical"
        />
      )}
      renderThumbVertical={props => {
        return (
          <div
            {...props}
            style={{
              ...props.style,
              backgroundColor: 'var(--aluminium35)',
              borderRadius: 10,
            }}
            className="thumb-vertical"
          />
        );
      }}
    >
      {props.children}
    </Scrollbars>
  );
};

CustomScrollbar.propTypes = propTypes;

export default CustomScrollbar;
